import { getFreezeBlockReport } from '../../services/api/customerReportApi';
import {
    SET_FREEZE_BLOCK_FILTERS,
    GET_FREEZE_BLOCK_REPORT,
    CLEAR_FREEZE_BLOCK_REPORT,
} from './actionTypes';
import { hideLoading, showLoading } from './loadingActions';
import { notifyError } from './notificationActions';

export const setFreezeBlockFilters = (filters) => {
    return {
        type: SET_FREEZE_BLOCK_FILTERS,
        filters,
    };
};

export const getFreezeBlockReportAction = (reportData, totalCount) => {
    return {
        type: GET_FREEZE_BLOCK_REPORT,
        reportData,
        totalCount,
    };
};

export const clearFreezeBlockReport = () => {
    return {
        type: CLEAR_FREEZE_BLOCK_REPORT,
    };
};

export function fetchFreezeBlockReport(
    market,
    category,
    brand,
    fromDate,
    toDate,
    gigyaId = '',
    promotionType = '',
    start = 0,
    limit = 10
) {
    return function (dispatch, getState) {
        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() =>
                getFreezeBlockReport(
                    market,
                    category,
                    brand,
                    fromDate,
                    toDate,
                    gigyaId,
                    promotionType,
                    start,
                    limit
                )
            )
            .then((response) => response?.data)
            .then((data) =>
                dispatch(
                    getFreezeBlockReportAction(
                        data?.results || [],
                        data?.totalCount || 0
                    )
                )
            )
            .catch((error) =>
                dispatch(
                    notifyError('Error!', 'Unable to fetch freeze/block report')
                )
            )
            .finally(() => dispatch(hideLoading()));
    };
}
